import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import 'sass/app.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from 'store'
import GlobalComponentInstaller from 'components/global'
import Api from './api'
import i18n from './utilities/i18n'
import udi from './utilities/udi'
import directive from './plugins/click-outside/directive'
import './plugins/svg-sprite-loader'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import Vuency from 'vuency'
import PrismicVue from 'prismic-vue'
import siteConfig from 'siteConfig'
import { updatePageName, trackConversion } from 'utilities/common/trackConversion'
import VModal from 'vue-js-modal'
import eventBus from '@/plugins/event-bus'
import * as filters from './plugins/global-filters'
import VueScrollTo from 'vue-scrollto'
import VueMeta from 'vue-meta'
import VTooltip from 'v-tooltip'
// GA implementation
import analytics from 'utilities/common/analytics.js'

Vue.config.productionTip = false

GlobalComponentInstaller(Vue)
Vue.use(Api, { mock: false })
Vue.use(i18n)
Vue.use(udi)
Vue.use(Vuelidate)
Vue.use(Notifications)
Vue.use(Vuency)
Vue.directive('click-outside', directive)
Vue.use(PrismicVue, {
  endpoint: siteConfig.prismic.endpoint,
  apiOptions: { accessToken: siteConfig.prismic.token }
})
Vue.use(trackConversion)
Vue.prototype.updatePageName = updatePageName
Vue.use(VModal)
Vue.use(eventBus)
Vue.use(VueScrollTo)
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(VueMeta)

Vue.use(VTooltip)
Vue.use(analytics)


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
